import * as types from '../constants/actionTypes';
import { wrapCall } from '../utils/serviceUtils';
import { api } from '../utils/services';

export const resetUsersData = (fields) => {
  return {
    type: types.RESET_USERS_DATA,
    fields
  };
};
export const resetSUsersData = (fields) => {
  return {
    type: types.RESET_S_USERS_DATA,
    fields
  };
};

export const fetchUsers = (search, page = 1, perPage = 100, isLoadingDisabled) => {
  return wrapCall(
    api.get(`/userB/users?page=${page}&perPage=${perPage || 100}${search ? '&search=' + search : ''}`),
    types.FETCH_USERS,
    {isLoadingDisabled}
  );
};
export const fetchSUsers = (search, page, perPage, isLoadingDisabled) => {
  return wrapCall(
    api.get(`/userB/users?page=${page}&perPage=${perPage || 10}${search ? '&search=' + search : ''}`),
    types.FETCH_S_USERS,
    {isLoadingDisabled}
  );
};

export const fetchUser = (id) => {
  return wrapCall(
    api.get(`/userB/users/${id}`),
    types.FETCH_USER,
    {id}
  );
};
